
import {mask} from "vue-the-mask";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";
import {Component, Mixins, Prop, Watch} from "vue-property-decorator";
import {TakipDurumu} from "@/enum/TakipDurumu";

@Component({
  directives: {
    mask
  }
})
export default class DosyaEsasNumarasi extends Mixins(SimpleInputMixin) {
  @Prop() label !: string;
  @Prop() placeholder !: string;
  @Prop() rules !: any;
  @Prop() dense !: string | boolean;
  @Prop() hideDetails !: string | boolean;
  @Prop() disabled !: string | boolean;

  // UYAP ilam ekranında sıra no 6 hane; ancak bu bileşen UYAP dışı bağlamlarda da kullanılıyor
  // ve v-mask maskeye sığmayan MEVCUT değeri render anında kırpıp input olayı yaydığı için
  // maske daraltılmıyor (sessiz veri kaybı olur).
  maskStr = "####/#######";

  get isDense() {
    return this.dense || this.dense === "";
  }

  get isHideDetails() {
    return this.hideDetails || this.hideDetails === "";
  }

  get dosyaNoRules(){
    if(this.localValue){
      let rule : any = [];
      if(this.localValue.length < 6){
        rule = ["Minimum 6 karakter"];
      }
      return rule;
    }
  }

  get isDisabled() {
    return this.disabled || this.disabled === "";
  }

  validate() {
    this.$emit("value", this.localValue);
  }
}
